<div class="row row--primary tile d-block opacity-container" [class.active]="isReady">
  <a class="d-flex align-items-center link-secondary mb-3 cursor-pointer" (click)="goBack.emit()">
    <svg class="icon icon-18 mr-1">
      <use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" />
    </svg>
    {{ 'trade.confirm.back' | transloco }}
  </a>
  <trade-confirm-quote
    [asset]="tradeService.asset$ | async"
    [quote]="tradeService.quote$ | async"
    [direction]="(tradeService.cache$ | async)?.form?.get('direction')?.value"
  />
  <trade-confirm-data
    [quote]="tradeService.quote$ | async"
    [cache]="tradeService.cache$ | async"
    [orderVolume]="tradeService.orderVolume$ | async"
    [minimumQuantitySurcharge]="tradeService.minimumQuantitySurcharge$ | async"
  />
  <trade-confirm-hint [cache]="tradeService.cache$ | async" [minimumQuantitySurcharge]="tradeService.minimumQuantitySurcharge$ | async" />
  <trade-confirm-links [cache]="tradeService.cache$ | async" />
  <trade-confirm-button
    [minimumQuantitySurcharge]="tradeService.minimumQuantitySurcharge$ | async"
    [disabled]="tradeFacade.isPlacingOrder$ | async"
    (placeOrder)="placeOrder()"
    (confirmLowTradingAndPlaceOrder)="confirmLowTradingAndPlaceOrder()"
  />
</div>
